//用于webview调用
window.setHeaderVisible = function setHeaderVisible(statu) {
    $app.$store.commit("app/setHeaderVisible", statu);
};
